const WindowAdjustment = ({ 
    windowCenter, 
    windowWidth, 
    onWindowCenterChange, 
    onWindowWidthChange, 
    onReset, 
    disabled = false 
}) => {
    return (
        <div className="window-adjust">
            <div className="wa-row">
                <div className="wa-left">
                    <label className="wa-label">Window Center:</label>
                </div>
                <div className="wa-center">
                    <input 
                        className="wa-range"
                        type="range" 
                        min="-1000" 
                        max="1000" 
                        value={windowCenter} 
                        onChange={onWindowCenterChange}
                        disabled={disabled}
                    />
                </div>
                <div className="wa-right">
                    <input 
                        className="wa-number small-input"
                        type="number" 
                        value={windowCenter} 
                        onChange={onWindowCenterChange}
                        disabled={disabled}
                    />
                </div>
            </div>
            <div className="wa-row">
                <div className="wa-left">
                    <label className="wa-label">Window Width:</label>
                </div>
                <div className="wa-center">
                    <input 
                        className="wa-range"
                        type="range" 
                        min="1" 
                        max="2000" 
                        value={windowWidth} 
                        onChange={onWindowWidthChange}
                        disabled={disabled}
                    />
                </div>
                <div className="wa-right">
                    <input 
                        className="wa-number small-input"
                        type="number" 
                        value={windowWidth} 
                        onChange={onWindowWidthChange}
                        disabled={disabled}
                    />
                </div>
            </div>
            <button className="wa-btn btn-primary" onClick={onReset} disabled={disabled}>
                Reset Window/Level
            </button>
        </div>
    );
};

export default WindowAdjustment;
